const parallelPhotoKey = ({ type, variables }) =>
  type === 'UPLOAD_FIELD_PHOTO' && variables?.photoKey ? variables.photoKey : null;

export const processSyncOperations = async (operations, execute) => {
  const results = [];
  let batch = [];
  const flush = async () => {
    if (batch.length) results.push(...await Promise.all(batch.map(execute)));
    batch = [];
  };
  for (const operation of operations) {
    const key = parallelPhotoKey(operation);
    if (key) {
      if (batch.length === 2 || batch.some((entry) => parallelPhotoKey(entry) === key)) await flush();
      batch.push(operation);
    } else {
      await flush();
      results.push(await execute(operation));
    }
  }
  await flush();
  return results;
};
